<template>
  <card>
    <h4 slot="header" class="card-title">Yeni Segment</h4>
    <form>
      <div class="row">
        <div class="col-md-4">
          <base-input type="text"
                    label="Segment Adı"
                    placeholder="Segment Adı"
                    v-model="segment.name">
          </base-input>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">
              Segment Adı
            </label>
            <select class="form-control">
              <option>Türkiye</option>
              <option>İstanbul</option>
              <option>Şişli</option>
            </select>
          </div>
          
        </div>
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-info btn-fill float-right" @click.prevent="updateProfile">
          Kaydet
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        segment: {
          name: '',
          parent: ''
        }
      }
    },
    methods: {
      updateProfile () {
        console.log(JSON.stringify(this.segment))
      }
    }
  }

</script>
<style>

</style>
